export const ALERTS = "[Alerts]";

export const INSERT_ALERT = `${ALERTS} insert`;
export const REMOVE_ALERT = `${ALERTS} remove`;
export const SET_ALERTS = `${ALERTS} set`;
export const UPDATE_ALERT = `${ALERTS} update`;


export const  addAlert = (alert, meta) => ({
    type: INSERT_ALERT,
    payload: {
        data: alert,
        meta: meta
    }
});


export const  removeAlert = (alert) => ({
    type: REMOVE_ALERT,
    payload: {
        data: alert,
    }
});

export const  setAlerts = (alert) => ({
    type: SET_ALERTS,
    payload: {
        data: alert,
    }
});

export const updateAlert = (alert) => ({
    type: UPDATE_ALERT,
    payload: {
        data: alert
    }
});
